import { NgModule } from '@angular/core';
import { LoadingComponent } from './loading.component';

import { MaterialsModule } from '@library/common/materials';

@NgModule({
  declarations: [LoadingComponent],
  imports: [
     MaterialsModule,
  ],
  exports: [LoadingComponent]
})
export class LoadingModule { }
